// src/components/InfoCowork.js
import React, { useState } from 'react';
import styled from 'styled-components';

const InfoCardNewsContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 5% 15% 5% 15%;

  img{
    width:100%;
    padding:5% 0% 5% 0%;
  }

  @media (max-width: 500px) {
    padding:5%;
    display: flex;
    flex-direction: column;
  }
  
  


`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding:5% 0% 0% 0%;
  border-top: 1px solid #3F3F3F;


`;

const SectionTitle = styled.span`
  
  
  border-left:8px solid #FFF56A ;
  padding:0% 0% 0% 2.5%;
  display: flex;
  flex-direction: row;
  font-size: 36px;
    line-height: 52px;


  h3{
    color: #FFFFFF;
    font-weight: 700;
    font-size: 36px;
    line-height: 52px;
    letter-spacing: 0.05em;
    width:30%;
    margin: 0px;
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #AFAFAF;
    margin:auto 0;
    padding:0% 0% 0% 5%;
  }

  @media (max-width: 500px) {
    width:95%;
    display: flex;
    flex-direction: column;
    border-left:0;

    h3{
      color: #FFFFFF;
      font-weight: 700;
      font-size: 32px;
      line-height: 46px;
      letter-spacing: 0.05em;
      width:100%;
      margin: 0px;
      padding:0% 0% 0% 5%;
      border-left:8px solid #FFF56A ;
      margin-bottom: 10px;



    }

    p{
      padding-top: 5%;
      padding-left: 0;
      margin-left:0px;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;

    }
  }


`;





const InfoCowork = () => {
  




    return (
      <InfoCardNewsContainer>
        <SectionHeader>
          <SectionTitle><h3>協作紀錄</h3><p>本案執行團隊嘗試在標案工作項目外，運用有限人力資源，逐步開放與本案相關的過程資料，包含「Project、Action、Document」三項詮釋資料集，以此建構標案履約協力的開放資源與知識系統，供各界研究、參考。</p></SectionTitle>
      
        </SectionHeader>
        
        <iframe
          className="airtable-embed"
          src="https://airtable.com/embed/appR36t18KbAx9zQq/shrHx2Tst57dFIOcQ?backgroundColor=yellow"
          frameBorder="0"
          onWheel={() => {}}
          width="100%"
          height="533"
          style={{ background: 'transparent', border: '1px solid #ccc' , borderRadius: '30px' }}
        ></iframe>

        
          
      </InfoCardNewsContainer>
    );
  
};

export default InfoCowork;
